import { Select, Space } from "antd";
import CustomButton from "src/components/common/CustomButton";
import AppInput from "src/components/common/AppInput";
import type { InventoryType } from "src/types/warehouse";

type Props = {
  warehouseName: string;
  inventoryType: InventoryType | "";
  isActive: boolean | "";
  onChangeWarehouseName: (value: string) => void;
  onChangeInventoryType: (value: InventoryType | "") => void;
  onChangeIsActive: (value: boolean | "") => void;
  onSearch: () => void;
  onCreate: () => void;
};

export default function WarehouseFilterBar({
  warehouseName,
  inventoryType,
  isActive,
  onChangeWarehouseName,
  onChangeInventoryType,
  onChangeIsActive,
  onSearch,
  onCreate,
}: Props) {
  return (
    <Space size={12} align="center" style={{ marginBottom: 12 }}>
      <AppInput
        placeholder="창고명 검색"
        value={warehouseName}
        onChange={(e) => onChangeWarehouseName(e.target.value)}
        onPressEnter={onSearch}
        style={{ width: 200 }}
      />

      <Select
        placeholder="재고관리타입"
        value={inventoryType || undefined}
        onChange={(value) => onChangeInventoryType(value || "")}
        allowClear
        style={{ width: 150 }}
        options={[
          { label: "전체", value: "" },
          { label: "수동(MANUAL)", value: "MANUAL" },
          { label: "WMS", value: "WMS" },
          { label: "입점사", value: "DELEGATE" },
        ]}
      />

      <Select
        placeholder="활성상태"
        value={isActive === "" ? undefined : isActive}
        onChange={(value) => onChangeIsActive(value === undefined ? "" : value)}
        allowClear
        style={{ width: 120 }}
        options={[
          { label: "활성", value: true },
          { label: "비활성", value: false },
        ]}
      />

      <CustomButton variant="outlined" onClick={onSearch}>
        검색
      </CustomButton>

      <CustomButton variant="contained" onClick={onCreate}>
        창고 등록
      </CustomButton>
    </Space>
  );
}
